import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** "Dr. Luis" / "Dra. Ana" (legacy: H = hombre, M = mujer); si no se conoce, solo el nombre. */
export function tratamiento(nombre: string, genero: string | null | undefined): string {
  const primero = nombre.trim().split(/\s+/)[0] ?? '';
  if (genero === 'H') return `Dr. ${primero}`;
  if (genero === 'M') return `Dra. ${primero}`;
  return primero;
}

export function iniciales(nombre: string): string {
  return nombre
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
